import * as React from "react";
// import { pure } from 'recompose';
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
// import * as Utils from '@Cyclope-Utils/index';
// import * as Enums from '@tunnel-enums/index';
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as i18next from "i18next";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onSubmit,
    someInputUpdateError,
    isVisible,
    rightdata,
    emailUpdateError,
    nameError,
    firstnameError,
    onOpenModal,
    onChangeRoleUser,
    userObject,
    onChange,
    nameUser,
    firstNameUser,
    emailUser,
    roleUser,
    errorUpdateUser,
  } = props;

  ///  Simple Authorization + some operations

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean ( token )
   * @const
   * @name authorization
   * @type { boolean  }
   */

  const authorizationremove: any = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSUPDATED,
  ]);

  //
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isVisible}>
      <StyledComponent.ModalContainerInsider
        isVisible={isVisible}
        style={{
          overflow: "visible",
          width: "660px",
          backgroundColor: "unset",
        }}
      >
        {isVisible && (
          <BoxGrid
            title={i18next.t("mise a jour du profil")}
            onClose={onOpenModal}
            classNames="boderShadow changed-btn-pwd animated slideInDown"
            error={!authorizationremove}
            onSubmit={onSubmit}
            BtnTextSpan={i18next.t("valider")}
          >
            <Styled.CartContainer style={{ overflow: "hidden" }}>
              <div className="extractionInfo left">
                <div className="titleAction">
                  <h2>{i18next.t("nom")} : </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput error={nameError}>
                      <StyledComponent.Input
                        type="text"
                        name="nameuser"
                        placeholder={userObject.lastName}
                        value={nameUser}
                        autoComplete="off"
                        onChange={onChange}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                  <div>
                    {nameError && (
                      <span style={{ color: "#ed5b56", fontSize: "10px" }}>
                        {i18next.t("synthaxe invalide")}
                      </span>
                    )}
                  </div>
                </div>
                <div className="titleAction">
                  <h2>{i18next.t("prenom")} : </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput error={firstnameError}>
                      <StyledComponent.Input
                        type="text"
                        name="firstnameUser"
                        placeholder={userObject.firstName}
                        value={firstNameUser}
                        autoComplete="off"
                        onChange={onChange}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                  <div>
                    {firstnameError && (
                      <span style={{ color: "#ed5b56", fontSize: "10px" }}>
                        {i18next.t("synthaxe invalide")}
                      </span>
                    )}
                  </div>
                </div>
                <div className="titleAction">
                  <h2>{i18next.t("email")} : </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput error={emailUpdateError}>
                      <StyledComponent.Input
                        type="text"
                        name="emailuser"
                        placeholder={userObject.email}
                        value={emailUser}
                        autoComplete="off"
                        onChange={onChange}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                  <div>
                    {emailUpdateError && (
                      <span style={{ color: "#ed5b56", fontSize: "10px" }}>
                        {i18next.t("email invalide")}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="extractionInfo left">
                <div className="titleAction">
                  <h2>{i18next.t("role")} : </h2>
                  <select
                    style={{ color: "#88898a" }}
                    name="roleuser"
                    id="roleUser"
                    multiple={true}
                    className="selectRoleMultiple"
                    placeholder={i18next.t("superviseur")}
                    value={roleUser}
                    onChange={onChangeRoleUser}
                  >
                    {rightdata &&
                      rightdata.map((elem: any, index: number) => (
                        <option key={index} value={elem}>
                          {" "}
                          {i18next.t(elem)}
                        </option>
                      ))}
                  </select>

                  <ul className="listauthorities">
                    {userObject.authorities.map((elem: any, index: number) => (
                      <span key={index}>{i18next.t(`${elem}`)}</span>
                    ))}
                  </ul>
                </div>
              </div>
            </Styled.CartContainer>
          </BoxGrid>
        )}
      </StyledComponent.ModalContainerInsider>
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={errorUpdateUser}
        someTextSuccees={i18next.t("Impossible de modifier cet utilisateur")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={someInputUpdateError}
        someTextSuccees={i18next.t("synthaxe invalide")}
      />
    </StyledComponent.ModalContainer>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  onSubmit?: any;
  onOpenModal?: any;
  onChange?: any;
  nameUser?: any;
  firstNameUser?: any;
  emailUser?: any;
  roleUser?: any;
  userhas?: any;
  errorUpdateUser?: boolean;
  userObject?: any;
  onChangeRoleUser?: any;
  someInputUpdateError?: any;
  emailUpdateError?: any;
  nameError?: any;
  firstnameError?: any;
  isVisible?: boolean;
  rightdata?: any;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/users/update/component.tsx